
<!--NOTE BY TANARIN.KH
    1.วันที่รับ / คืนวัสดุ จะไม่สามารถแก้ไขถ้า ถ้าพบรายการวัสดุอุปกรณ์ เนื่องจากได้ผูกกับจำนวนที่พร้อมให้บริการไว้ ณ วันนั้นๆ ไว้- แก้วันที่ได้ ถ้าจำนวนรายการเป็น 0
    2.ใขั้นตอนการบันทึกจะผูกกับตาราง
      main ส่วนหัวของใบยืม รายละเอียด
      list ส่วนของรายการและจำนวน + ผูกกับประเภทการกดเพิ่มด้วย เพิ่มจากรายการเอง หรือเพิ่มจากการใช้ระบบแนะนำ add_type 0เพิ่มเอง 1 แนะนำ
      log ส่วนของประวัติการบันทึกแก้ไขสถานะต่างๆ
      rec ส่วนของระบบแนะนำ ประวัติว่ามีการใช้คำแนะนำ ใดไปบ้าง เก็บแค่ ประเภทกิจกรรมกับ รหัสเอกสารการยืม
          [ บันทึกทุกกิจกรรมที่เลือกถึงแม้จะมีการลบออก หรือเปลี่ยน ประเภทภายหลัง ] * อาจพิจารณาในส่วนของการกดดูแต่ไม่เพิ่มรายการ ใดเลย

NOTE-->


<template>
  <v-container fluid class="equipmentBR-management mt-4 px-1">
    <v-row>


      <!-- Modal ชื่อ dialogRemark -->
      <v-dialog v-model="dialogRemark" max-width="850px">
        <v-card>
          <v-card-title>
            <span class="text-h6">สถานะเอกสาร</span>
          </v-card-title>
          <v-card-text>

            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                :headers="remark_headers"
                :items="remark_items"
                item-value="id"
            >
              <!-- Template สำหรับคอลัมน์ updated_at -->
              <template v-slot:item.updated_at="{ item }">
                <span>{{ dataFormatter.dateFormatterTH(item.updated_at, 1) }}</span>
              </template>


              <template v-slot:item.borrowing_status="{ item }">
    <span
        v-if="getStatusData(item.borrowing_status)"
        :class="`v-chip theme--light v-size--small ${getStatusData(item.borrowing_status).color}`"
    >
      <span class="v-chip__content">{{ getStatusData(item.borrowing_status).title_th }}  </span>
    </span>
                <span v-else class="v-chip theme--light v-size--small default">
      <span class="v-chip__content">สถานะไม่ทราบ</span>
    </span>

              </template>


            </v-data-table>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                outlined
                class="button-shadow mr-4"
                @click="dialogRemark = false"
            >
              ปิด
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- กล่องข้อความสำหรับเพิ่มรายการวัสดุ -->
      <v-dialog v-model="dialog" max-width="850px">
        <v-card class="mb-1">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>
          </v-card-title>

          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form2"
                v-model="editedEquipmentItem.valid"
                lazy-validation
            >
              <v-row align="center">

                <v-col cols="12" sm="4">
                  <v-img
                      v-if="this.editedEquipmentItem.item_h_image"
                      :src="this.editedEquipmentItem.item_h_image"
                      max-height="200"
                      contain
                      alt="Selected Item"
                  ></v-img>
                </v-col>

                <v-col cols="12" sm="8">
                  <v-row align="center">
                    <v-col class="d-flex" cols="12" sm="12">
                      <v-combobox
                          :disabled="editedEquipmentItem.add_type==1?true:false"
                          v-model="editedEquipmentItem.item_id_full"
                          :items="e_i_tem_combo"
                          item-text="item_name"
                          item-value="item_id"
                          chips
                          clearable
                          label="รายการวัสดุอุปกรณ์"
                          :rules="[v => !!v || 'กรุณาเลือกวัสดุอุปกรณ์']"
                          @change="onItemSelected"
                      >
                        <template v-slot:item="data">
                          <div
                              style="display: flex; align-items: center;"
                              @mouseenter="onMouseEnter(data.item)"
                              @mouseleave="onMouseLeave"
                          >
                      <span style="font-weight: bold; margin-right: 10px;">
                        <v-avatar>
                          <img
                              :src="baseURLStorage+data.item.item_h_image"
                              alt=""
                          >
                        </v-avatar> {{ data.item.item_name }}
                      </span>
                          </div>
                        </template>

                        <template v-slot:selection="{ attrs, item }">
                          <v-avatar>
                            <img
                                :src="baseURLStorage+item.item_h_image"
                                alt=""
                            >
                          </v-avatar>
                          <strong>{{ item.item_name }}</strong>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>

                  <v-row align="center">
                    <v-col class="d-flex" cols="12" sm="6">
                      <v-text-field
                          v-model="editedEquipmentItem.item_quantity"
                          :counter="4"
                          label="จำนวนที่พร้อมให้บริการ"
                          disabled
                          required
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="6">
                      <v-text-field
                          v-model="editedEquipmentItem.borrowing_list_quantity"
                          :counter="4"
                          label="จำนวนที่ต้องการยืม"
                          :rules="[
                                       v => !!v || 'กรุณาระบุจำนวนที่ต้องการยืม', // ตรวจสอบว่ามีค่า
            v => !isNaN(v) || 'กรุณากรอกตัวเลขเท่านั้น', // ตรวจสอบว่าเป็นตัวเลข
            v => v > 0 || 'จำนวนต้องมากกว่า 0' // ตรวจสอบว่ามากกว่า 0
                                    ]"
                          required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row align="center">
                    <v-col class="d-flex" cols="12" sm="12">
                      <v-text-field
                          v-model="editedEquipmentItem.remarks"
                          label="หมายเหตุถึงเจ้าหน้าที่"

                          required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                </v-col>

              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="secondary"
                outlined
                class="button-shadow mr-4"
                @click="closeEquipment"
            >
              ยกเลิก
            </v-btn>
            <v-btn
                :disabled="!editedEquipmentItem.valid"
                color="primary"
                class="button-shadow mr-4"
                @click="saveEquipment"
            >
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



<!--      &lt;!&ndash; กล่องข้อความสำหรับลบรายการรายการวัสดุ &ndash;&gt;
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">คุณต้องการ ลบรายการวัสดุนี้ ใช่หรือไม่ ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeEquipmentDelete">ยกเลิก</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemEquipmentConfirm">ยืนยัน</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>-->


      <v-col cols="12">

        <!--หน้าแรก แสดงรายการ-->
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>ยืมคืนวัสดุอุปกรณ์</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{
              '\xa0 (' + equipmentBRs.length
            }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      @change="searchData"
                      v-model="search_data.borrowing_status"
                      :items="borrowing_status_text_color"
                      item-text="title_th"
                      item-value="status_code"
                      label="สถานะเอกสาร"
                      clearable=""
                  ></v-select>

                </v-col>


                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>

            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting || isUpdating"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="equipmentBRs"
                :search="search"
                sort-by="item_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>

                  <v-menu offset-y  v-if="currentUser.role=='admin'">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="mr-3 ml-3 button-shadow"
                          color="primary"
                          outlined
                          dark
                          v-bind="attrs"
                          v-on="on"
                      >
                        พิมพ์รายงาน
                      </v-btn>
                    </template>

                    <v-list>
                      <div class="custom-grid">
                        <v-list-item
                            @click="downloadReport3('0','pdf')"
                        >
                          <v-list-item-title>
                           1.อยู่ระหว่างเตรียม
                          </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            @click="downloadReport3(1,'pdf')"
                        >
                          <v-list-item-title>
                            2.รับวัสดุอุปกรณ์แล้ว
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="downloadReport3(2,'pdf')"
                        >
                          <v-list-item-title>
                            3.คืนวัสดุอุปกรณ์แล้ว
                          </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            @click="downloadReport3(3,'pdf')"
                        >
                          <v-list-item-title>
                            4.ชำรุญ/สูญหาย
                          </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            @click="downloadReport2('pdf')"
                        >
                          <v-list-item-title>
                            4.เลยกำหนดคืนวัสดุอุปกรณ์
                          </v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>


                </template>


              </template>

              <template v-slot:item.created_at="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.created_at, 3) }}</span>
              </template>


              <template v-slot:item.borrowing_title="{ item }">
                <span> {{ item.borrowing_title }} <sup
                    v-if="item.fname_th!='undefined' && item.fname_th!=null">{{ item.fname_th + ' ' + item.lname_th }} </sup></span>
              </template>


              <template v-slot:item.start_date="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.start_date, 3) }}</span>
              </template>

              <template v-slot:item.end_date="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.end_date, 3) }}</span>
              </template>


              <template v-slot:item.borrowing_status="{ item }">
    <span
        v-if="getStatusData(item.borrowing_status)"
        :class="`v-chip theme--light v-size--small ${getStatusData(item.borrowing_status).color}`"
    >
      <span class="v-chip__content">{{ getStatusData(item.borrowing_status).title_th }}  </span>
    </span>
                <span v-else class="v-chip theme--light v-size--small default">
      <span class="v-chip__content">สถานะไม่ทราบ</span>
    </span>

                <v-btn icon small @click="showRemark(item.borrowing_id)">
                  <v-icon color="greyTint" title="สถานะเพิ่มเติม">mdi-information</v-icon>
                </v-btn>

              </template>


              <template v-slot:item.api="{ item }">

                <v-btn
                    @click="downloadReport(item.borrowing_id,'pdf')"
                    small
                    class="mr-3 button-shadow"
                    color="warning"
                >ใบยืม
                </v-btn>


                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                    :disabled="!borrowing_status_text_color.find(items => items.status_code === item.borrowing_status).edit && currentUser.role!='admin'"
                >แก้ไข
                </v-btn>


               <v-btn
                    class="mr-3 button-shadow"
                    @click="updateStatusItem(item.borrowing_id,'RC','รับวัสดุ')"
                    small
                    color="success"
                    v-if="(borrowing_status_text_color.find(items => items.status_code === item.borrowing_status).receive && currentUser.role!='admin')"
                >รับวัสดุ
                </v-btn>

                <!-- <v-btn
                         class="mr-3 button-shadow"
                         @click="updateStatusItem(item.borrowing_id,'RT','คืนวัสดุ')"
                         small
                         color="success"
                         v-if="(borrowing_status_text_color.find(items => items.status_code === item.borrowing_status).return && currentUser.role=='admin')"
                     >รับคืนวัสดุทั้งหมด
                     </v-btn> -->


                <v-menu offset-y  v-if="currentUser.role=='admin'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-3 button-shadow"
                        color="primary"
                        small
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                      เปลี่ยนสถานะ
                    </v-btn>
                  </template>

                  <v-list>
                    <div class="custom-grid">
                      <v-list-item
                          v-for="(item2, index) in borrowing_status_text_color"
                          :key="index"
                          @click="updateStatusItem(item.borrowing_id,item2.status_code,item2.title_th)"

                      >
                        <v-list-item-title>
                          {{index+1}}.{{ item2.title_th }}  <v-icon small color="success" v-show="item.borrowing_status==item2.status_code">mdi-check-circle</v-icon>
                        </v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>






                <v-btn
                    @click="updateStatusItem(item.borrowing_id,'CX','ยกเลิก')"
                    small
                    class="button-shadow"
                    color="secondary"
                    :disabled="!borrowing_status_text_color.find(items => items.status_code === item.borrowing_status).cancel && currentUser.role!='admin' "
                >ยกเลิก
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <!--หน้าสำหรับเพิ่ม / แก้ไข-->
        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.borrowing_id"
                      :rules="editForm.textReqRules"
                      label="รหัสเอกสาร"
                      required
                      readonly
                      disabled

                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.created_at_text"
                      :rules="editForm.textReqRules"
                      label="วันที่เอกสาร"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.full_name_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อ-นามสกุล (ผู้ยืม)"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.job_title"
                      label="สังกัด"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.phone_number"
                      :rules="editForm.textReqRules"
                      label="หมายเลขโทรศัพท์"
                      required
                  ></v-text-field>


                </v-col>


              </v-row>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="2">

                  <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"

                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          @change="clearableDate('start')"
                          v-model="dateFormatted3"
                          label="วันที่จะรับวัสดุอุปกรณ์"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="editForm.textReqRules"
                          clearable
                          :disabled="equipment_br_items && equipment_br_items.length > 0"
                      ></v-text-field>
                    </template>
                    <v-date-picker

                        v-model="date3"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>


                </v-col>
                <v-col class="d-flex" cols="12" sm="2">


                  <v-menu
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          @change="clearableDate('end')"
                          v-model="dateFormatted4"
                          label="วันที่จะคืนวัสดุอุปกรณ์"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="editForm.textReqRules"
                          clearable
                          :disabled="equipment_br_items && equipment_br_items.length > 0"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date4"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu4 = false"
                    ></v-date-picker>
                  </v-menu>


                </v-col>

                <v-col class="d-flex" cols="12" sm="8">
                  <v-text-field
                      v-model="editForm.borrowing_title"
                      :rules="editForm.textReqRules"
                      label="เพื่อใช้ในงาน"
                      required
                  ></v-text-field>


                </v-col>
              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4" v-if="checkType(editForm.user_name)">


                  <v-select
                      v-model="editForm.certifier_user_name"
                      :items="users_combo"
                      item-text="full_name_th"
                      item-value="user_name"
                      :rules="editForm.textReqRules"
                      label="ผู้รับรองการยืม (กรณีนิสิต)"
                      clearable=""

                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" :sm="checkType(editForm.user_name)==true?8:12">
                  <v-text-field
                      v-model="editForm.borrowing_place_title"
                      :rules="editForm.textReqRules"
                      label="สถานที่ที่นำไปใช้"
                      required
                  ></v-text-field>


                </v-col>
              </v-row>


              <v-card class="mb-1">


                <v-card-title class="pa-5 pb-3">
                  <p>รายการวัสดุอุปกรณ์</p>
                  <span class="grey--text font-weight-regular subtitle-2 pt-1">{{
                      '\xa0 (' + this.equipment_br_items.length
                    }} รายการ) </span>
                  <v-spacer></v-spacer>

                </v-card-title>

                <v-card-text class="px-5">
                  <v-row>
                    <v-col class="d-flex" cols="12" sm="8">
                      <v-data-table style="width: 100%"
                                    :loading="isReceiving || isDeleting"
                                    loading-text="Loading... Please wait"
                                    class="product-table"
                                    :headers="equipment_headers"
                                    :options="equipment_options"
                                    :items="this.equipment_br_items"
                                    sort-by="borrowing_id">
                        <template v-slot:top>


                          <template>
                            <v-btn
                                color="success"
                                dark
                                class="my-4 button-shadow"
                                @click="addItemEquipment('',0)"
                            >เพิ่มรายการวัสดุอุปกรณ์
                            </v-btn>
                          </template>


                        </template>


                        <template v-slot:item.item_id_full="{ item }">
                          {{ item.item_id_full.item_name }}

                        </template>

                        <template v-slot:item.return_status="{ item }">


    <span
        v-if="getReturnStatusData(item.return_status)"
        :class="`v-chip theme--light v-size--small ${getReturnStatusData(item.return_status).color}`"
    >
      <span class="v-chip__content">{{ getReturnStatusData(item.return_status).title_th }} </span>
    </span>
                          <span v-else class="v-chip theme--light v-size--small default">
      <span class="v-chip__content">สถานะไม่ทราบ</span>
    </span>

                        </template>


                        <template v-slot:item.api="{ item }">
                          <v-btn
                              class="mr-3 button-shadow"
                              @click="editItemEquipment(item)"
                              small
                              color="success"
                          >แก้ไข
                          </v-btn>

                          <v-btn
                              class="mr-3 button-shadow"
                              @click="editItemEquipmentStatus(item)"
                              small
                              color="success"
                              v-if="(item.return_status=='1'&& currentUser.role=='admin')"

                          >คืนวัสดุ
                          </v-btn>


                          <v-btn
                              @click="deleteItemEquipment(item)"
                              small
                              class="button-shadow"
                              color="secondary"
                          >ลบ
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="4">

                      <v-card-text class="px-5">
                        <v-row>
                          <v-col class="d-flex" cols="12" sm="12">
                            <v-data-table style="width: 100%"
                                          :loading="isReceiving || isDeleting|| isLoading "
                                          loading-text="Loading... Please wait"
                                          class="product-table"
                                          :headers="activity_headers"
                                          :options="activity_options"
                                          :items="this.activity_items"
                                          :items-per-page="-1"
                                          hide-default-footer
                            >
                              <template v-slot:top>


                                <template>


                                  <b style="color: #536dfe; padding-left: 10px; font-size: 16pt " title="เลือกประเภทกิจกรรม ระบบจะแนะนำอุปกรณ์ที่ควรยืมให้กับท่าน">  <v-icon left color="#536dfe">mdi-plus-box</v-icon> ระบบแนะนำวัสดุอุปกรณ์ </b>

                                  <v-col class="d-flex" cols="12" sm="12">

                                    <v-select
                                        v-model="editForm.activity_id_search"
                                        :items="e_activity_combo"
                                        attach
                                        chips
                                        deletable-chips
                                        item-text="activity_name"
                                        item-value="activity_id"
                                        label="ระบุลักษณะหรือประเภทกิจกรรม"
                                        multiple
                                        color="primary"
                                        @change="fetchActivityItems"
                                    ></v-select>

                                  </v-col>
                                </template>


                              </template>


                              <template v-slot:item.item_id="{ item }">
                                {{ item.item_id }} - {{ item.item_name }}

                              </template>


                              <template v-slot:item.api="{ item }">

                                <v-btn
                                    class="mr-3 button-shadow"
                                    @click="addItemEquipment(item.item_id,1)"
                                    small
                                    color="success"
                                >เพิ่ม
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-col>

                        </v-row>


                      </v-card-text>


                    </v-col>
                  </v-row>


                </v-card-text>


              </v-card>


              <br>

              <v-row align="center" v-if="this.currentUser.role=='admin' &&state=='editForm'">
                <v-chip

                    color="secondary"
                    class="ma-2"
                >
                  สำหรับเจ้าหน้าที่/ผู้ดูแลระบบ
                </v-chip>



                <v-col class="d-flex" cols="12" sm="3">

                  <v-select

                      v-model="editForm.borrowing_status"
                      :rules="editForm.textReqRules"
                      :items="borrowing_status_text_color"
                      item-text="title_th"
                      item-value="status_code"
                      label="สถานะเอกสาร"
                      clearable=""
                      required
                      disabled
                  ></v-select>

                </v-col>
              </v-row>

              <br>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="addItem"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>

    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import dataFormatter from "@/use/dataFormatter";
import axios from "axios";


export default {
  name: 'EquipmentBR',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      menu2: false,
      date3: '',
      date4: '',
      dateFormatted3: '',
      dateFormatted4: '',
      menu3: false,
      menu4: false,

      dialog: false,
      //dialogDelete: false,
      dialogRemark: false,

      isLoading: false, // ตัวแปรสถานะการโหลด
      state: 'index',
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      search: '',
      search_data: {
        borrowing_status: "",
        start_date: '',
        end_date: '',
      },
      selected: [],
      headers: [
        {
          text: 'รหัสเอกสาร',
          align: 'start',
          value: 'borrowing_id',
        },
        {text: 'วันที่เอกสาร', value: 'created_at'},
        {text: 'เพื่อใช้ในงาน', value: 'borrowing_title'},
        {text: 'กำหนดรับ', value: 'start_date'},
        {text: 'กำหนดส่งคืน', value: 'end_date'},
        {text: 'สถานะเอกสาร', value: 'borrowing_status'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ["borrowing_id"],
        sortDesc: [true]
      },
      e_i_tem_type_master_combo: [],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {

        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
        activity_id_search: '',
        activity_id_search_history:  new Set() // ใช้ Set เพื่อป้องกันค่าซ้ำ
      },


      equipment_br_items: [],  // desserts
      editedEquipmentIndex: -1, //editedIndex
      editedEquipmentItem: {  //editedItem
        item_id_full: null,
        item_h_image: null,
        item_id: '',
        item_quantity: 0,
        borrowing_list_quantity: 0,
        remarks: '',
        add_type: 0
      },
      defaultEquipmentItem: { //defaultItem
        item_id: '',
        item_quantity: 0,
        borrowing_list_quantity: 0,
        remarks: '',
        add_type: 0
      },


      equipment_headers: [
        {
          text: 'รายการ',
          align: 'start',
          value: 'item_id',
        },
        {
          text: 'รายการ',
          value: 'item_id_full',
        },
        {text: 'จำนวน', value: 'borrowing_list_quantity'},
        {text: 'หมายเหตุ', value: 'remarks'},
        {text: 'สถานะ', value: 'return_status'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      equipment_options: {
        sortBy: ['updated_at'],
        sortDesc: [true]
      },
      e_i_tem_combo: {},
      borrowing_status_text_color: [
        {
          "status_code": "RR",
          "title_th": "รอรับรอง/รอเสนอ",
          "title_en": "Requesting Review",
          "color": "warning",
          "edit": true,
          "cancel": true,
          "receive": false,
          "return": false,

        },
        {
          "status_code": "RN",
          "title_th": "ไม่รับรอง",
          "title_en": "Review Not Accepted",
          "color": "default",
          "edit": false,
          "cancel": true,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "AC",
          "title_th": "รับรองแล้ว",
          "title_en": "Accepted Certification",
          "color": "success",
          "edit": false,
          "cancel": true,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "PA",
          "title_th": "อยู่ระหว่างเสนอ",
          "title_en": "Process Approval",
          "color": "warning",
          "edit": false,
          "cancel": true,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "AN",
          "title_th": "ไม่อนุมัติ",
          "title_en": "Approval Not Granted",
          "color": "default",
          "edit": false,
          "cancel": true,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "AP",
          "title_th": "อนุมัติแล้ว",
          "title_en": "Approval Provided",
          "color": "success",
          "edit": false,
          "cancel": true,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "PE",
          "title_th": "เตรียมอุปกรณ์",
          "title_en": "Preparing Equipment",
          "color": "secondary",
          "edit": false,
          "cancel": true,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "PS",
          "title_th": "เตรียมเสร็จ",
          "title_en": "Preparation Successful",
          "color": "success",
          "edit": false,
          "cancel": true,
          "receive": true,
          "return": false,
        },
        {
          "status_code": "RC",
          "title_th": "รับแล้ว",
          "title_en": "Received Confirmation",
          "color": "success",
          "edit": false,
          "cancel": false,
          "receive": false,
          "return": true,
        },
        {
          "status_code": "RT",
          "title_th": "คืนแล้ว",
          "title_en": "Returned",
          "color": "secondary",
          "edit": false,
          "cancel": false,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "ER",
          "title_th": "มีข้อผิดพลาด",
          "title_en": "Error Reported",
          "color": "default",
          "edit": false,
          "cancel": false,
          "receive": false,
          "return": false,
        },
        {
          "status_code": "CX",
          "title_th": "ยกเลิก",
          "title_en": "Cancelled Execution",
          "color": "default",
          "edit": false,
          "cancel": false,
          "receive": false,
          "return": false,
        }
      ],
      return_status_text_color: [
        {
          "status_code": 0,
          "title_th": "เตรียม",
          "color": "warning",
          "edit": true,
          "cancel": true,
        },
        {
          "status_code": 1,
          "title_th": "รับแล้ว",
          "color": "default",
          "edit": false,
          "cancel": false,
        },
        {
          "status_code": 2,
          "title_th": "คืนแล้ว",
          "color": "success",
          "edit": false,
          "cancel": false,
        },
        {
          "status_code": 3,
          "title_th": "ชำรุด",
          "color": "warning",
          "edit": false,
          "cancel": false,
        }

      ]
      ,
      users_combo: {},
      e_activity_combo: {},

      activity_items: [],  // desserts
      activity_headers: [
        {
          text: 'รายการแนะนำ',
          align: 'start',
          value: 'item_id',
        },
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      activity_options: {
        sortBy: ['activity_id', 'rule_priority'],
        sortDesc: [true, true]
      },
      remark_items: [],
      remark_headers: [

        {text: 'สถานะเอกสาร', value: 'borrowing_status'},
        {text: 'หมายเหตุ', value: 'remark'},
        {text: 'วันที่ทำรายการ', value: 'updated_at'},
        {text: 'บันทึกโดย', value: 'created_by'},

      ],
      materials: [
        { name: "กล้องถ่ายรูป", description: "IMILAB EC5" },
        { name: "ไมโครโฟน", description: "ไมโครโฟนสำหรับบรรยาย" },
        { name: "ขาตั้งกล้อง", description: "ขาตั้งสำหรับถ่ายภาพ" }
      ]
    }
  },
  components: {},
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('equipment_brs', ['equipmentBRs', "isReceiving", "isDeleting", "idToDelete", "equipmentBRMessage", "isUpdating", "errorMessage"]),

    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },

    //Date Picker Format
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

    //Date Picker Format
    computedDateFormatted3() {
      return this.formatDate(this.date3)
    },

    //Date Picker Format
    computedDateFormatted4() {
      return this.formatDate(this.date4)
    },

    computedDateMonthFormatted() {
      return this.formatDateMonth(this.datemonth)
    },
    //getDataUserLogin
    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),
    ...mapState({
      data: (state) => state.usersForm.data,
    }),
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้
    "editForm.activity_id_search": {
      deep: true,
      handler(newVal) {
        if (Array.isArray(newVal)) {
          // เพิ่มค่าทั้งหมดที่เลือกใหม่เข้าไปใน history
          newVal.forEach(id => this.editForm.activity_id_search_history.add(id));
        }
      }
    },

    equipmentBRMessage() {

      if (this.equipmentBRMessage !== '') {
        this.notification = this.equipmentBRMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    },
    //Date Picker Format
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    date3() {
      this.dateFormatted3 = this.formatDate(this.date3)
      this.checkStartEnd();
    },

    date4() {
      this.dateFormatted4 = this.formatDate(this.date4)
      this.checkStartEnd();
    },
    datemonth() {
      this.datemonthFormatted = this.formatDateMonth(this.datemonth)
    },

    //dialog equipment
    dialog(val) {
      val || this.closeEquipment()
    },
    /*dialogDelete(val) {
      val || this.closeEquipmentDelete()
    },*/


  },
  created() {
    this.addSuccessNotification();

  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getEquipmentBRsRequest(this.search_data);
    this.getUsersActive();
    this.getEActivityActive();
    this.resetValue();
    //Equipment
    this.getEItem();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('equipment_brs',
        [
          "getEquipmentBRsRequest",
          "deleteEquipmentBRRequest",
          "updateEquipmentBRRequest",
          "updateStatusEquipmentBRRequest",
          "createEquipmentBRRequest"
        ]
    ),
    ...mapActions('web_con_new_images', ["getWeb_con_new_imagesRequest"]),


    showAlert(title, icon) {
      this.$swal({
        title: "ขออภัย!",
        text: title,
        icon: icon,
        confirmButtonText: 'ตกลง',
      });
    },

    async showAlertDisableDate() {
      const result = await this.$swal({
        title: "โปรดยืนยัน!",
        text: "คุณจะไม่สามารถแก้ไขวันที่รับ-คืนได้ เมื่อเพิ่มรายการวัสดุอุปกรณ์แล้ว!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        allowOutsideClick: false, // Prevent closing by clicking outside
      });

      return result.isConfirmed;
    },
    async showAlertChangeStatus(id,text) {
      const result = await this.$swal({
        title: "โปรดยืนยัน!",
        text: "คุณต้องการเปลี่ยนสถานะรายการ ("+id+") เป็น "+text+" ใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        input: 'text',
        allowOutsideClick: false, // Prevent closing by clicking outside
      });

      return result;
    },

    async showAlertDeleteItem() {
      const result = await this.$swal({
        title: "โปรดยืนยัน!",
        text: "คุณต้องการ ลบรายการวัสดุอุปกรณ์นี้ใช่หรือไม่!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        allowOutsideClick: false, // Prevent closing by clicking outside
      });

      return result.isConfirmed;
    },

    async showAlertPolicySave() {
      const result = await this.$swal({
        width: 600,
        title: "ข้อตกลง!",
        html: "หากพัสดุ / ครุภัณฑ์ ที่นำมาส่งคืนชำรุดเสียหายหรือใช้การไม่ได้ หรือสูญหายไป ข้าพเจ้ายินดีชดใช้เป็นเงินตามราคาที่เป็นอยู่ในขณะยืม ตามหลักเกณฑ์ที่กระทรวงการคลังกำหนด",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยอมรับ",
        cancelButtonText: "ยกเลิก",
        allowOutsideClick: false, // Prevent closing by clicking outside
      });

      return result.isConfirmed;
    },

    resetValue() {
      this.editForm = {} //set null all value
      this.editForm = {
        valid: true,
        orderRules: validateRules.orderRules,
        textReqRules: validateRules.textReqRules,
        activity_id_search: '',
        activity_id_search_history: new Set() ,
        imageRules: validateRules.fileSingleRules(3),
        item_id: null,
        item_type_master_code: '',
        item_name: '',
        active: 'N',
        preview: '',
        avatarFile: null,
        avatarFileOld: null,
      }
    },



    async fetchActivityItems() {
      // Start loading indicator
      //this.isReceiving = true;
      this.isLoading = true;

      try {
        //  ดึงข้อมูลตามกิจกรรมที่เลือก
        const selectedIds = this.editForm.activity_id_search;


        console.log(selectedIds);
        if (selectedIds.length > 0) {


          const formData = new FormData();
          formData.append('activity_id_search', JSON.stringify(selectedIds)); // ส่งเป็น JSON string

          await axios.post(config.baseURLApi + '/get_eitem_activity', formData, {
            headers: {},
          }).then(res => {
            this.activity_items = res.data
          });


        } else {
          this.activity_items = []; // Clear data if no activity selected
        }
      } catch (error) {
        console.error("Error fetching activity items:", error);
      } finally {
        // Stop loading indicator
        //this.isReceiving = false;
        // ปิดสถานะการโหลด
        this.isLoading = false;
      }
    },


    async getUsersActive() {

      try {

        await axios.post(config.baseURLApi + '/combo/' + 'usersActive', '', {
          headers: {},
        }).then(res => {
          this.users_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },


    async getEActivityActive() {

      try {

        await axios.post(config.baseURLApi + '/combo/' + 'eActivityActive', '', {
          headers: {},
        }).then(res => {
          this.e_activity_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },


    async getEItem() {

      console.log(this.date3 + '-' + this.date4)
      try {

        await axios.post(config.baseURLApi + '/combo/' + 'eItem', '', {
          headers: {},
        }).then(res => {
          this.e_i_tem_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },

    async getBorrowingList(borrowing_id) {
      console.log(borrowing_id);

      try {
        const formData = new FormData();
        formData.append('borrowing_id', borrowing_id);

        await axios.post(config.baseURLApi + '/con_equipment_br_items', formData, {
          headers: {},
        }).then(res => {

          console.log(res.data);

          if (res.data.length > 0) {
            res.data.forEach(item => {
              item.item_id_full = this.getItemDetailsById(item.item_id);
            });
          }
          this.equipment_br_items = res.data;

        });

      } catch (e) {
        this.showSnackbar(e);
      }

    },

    addItem() {
      console.log(this.currentUser)
      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.date3 = ''
      this.date4 = ''
      this.editForm.borrowing_status = 'RR';
      this.editForm.borrowing_id = 'AUTO'
      this.editForm.created_at_text = dataFormatter.dateFormatterTH(new Date(), 3);
      this.equipment_br_items = [];
      this.editForm.user_name = this.currentUser.user_name;
      this.editForm.job_title = this.currentUser.job_title;
      this.editForm.full_name_th = this.currentUser.fname_th + ' ' + this.currentUser.lname_th;
      this.editForm.phone_number = this.currentUser.phone_number;
      this.activity_items = []; // Clear data
      this.state = 'addForm';
    },

    async editItem(item) {

      const isValid = await this.checkBorrowingStatus(item.borrowing_status, 'edit');

      if (isValid) {
        this.resetValue();
        this.editedIndex = this.equipmentBRs.indexOf(item) //index ของ row ที่จะแก้ไข
        this.editForm.borrowing_id = item.borrowing_id * 1;
        this.editForm.user_name = item.user_name;
        this.editForm.borrowing_title = item.borrowing_title;
        this.editForm.borrowing_place_title = item.borrowing_place_title;

        // this.editForm.start_date = item.start_date;
        this.date3 = item.start_date;
        this.dateFormatted3 = this.formatDate(item.start_date);

        // this.editForm.end_date = item.end_date;
        this.date4 = item.end_date;
        this.dateFormatted4 = this.formatDate(item.end_date);
        this.editForm.certifier_user_name = item.certifier_user_name;
        this.editForm.borrowing_status = item.borrowing_status;
        this.editForm.created_at_text = dataFormatter.dateFormatterTH(item.created_at, 3);
        this.editForm.job_title = item.job_title;
        this.editForm.full_name_th = item.fname_th + ' ' + item.lname_th;
        this.editForm.phone_number = item.phone_number;

        this.getBorrowingList(item.borrowing_id * 1); // get lis item to equipment_br_items

        this.activity_items = []; // Clear data
        this.state = 'editForm';
      }

    },

    deleteItem(item) {

      //check status ห้ามลบ
      confirm('ต้องการยกเลิกรายการนี้หรือไม่?') && this.deleteEquipmentBRRequest({borrowing_id: item.borrowing_id})

    },

   async updateStatusItem(borrowing_id,borrowing_status,text) {


     const isConfirmed = await this.showAlertChangeStatus(borrowing_id,text);
     // console.log(isConfirmed);
     if(isConfirmed.isConfirmed){
       this.updateStatusEquipmentBRRequest({
         borrowing_id: borrowing_id,
         borrowing_status: borrowing_status,
         remark: text+":"+isConfirmed.value
       })

     }


    },

    close() {

      if (this.errorMessage == false || this.equipmentBRMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },

    async save() {

      // สร้าง เพิ่ม list เข้าไปใน editForm

      this.editForm.start_date = this.date3;
      this.editForm.end_date = this.date4;
      this.editForm.equipment_br_items = this.equipment_br_items;
      console.log(this.equipment_br_items)


      if (this.equipment_br_items.length == 0) {

        this.showAlert("โปรดระบุรายการวัสดุอุปกรณ์ที่ต้องการยืม", "warning")

        return false;
      } else {
        const isValid = await this.showAlertPolicySave();
        console.log('save')

        if (isValid) {
          if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
            !config.isBackend ?
                Object.assign(this.equipmentBRs[this.editedIndex], this.editForm)
                :
                this.updateEquipmentBRRequest(this.editForm)
          } else {
            !config.isBackend ?
                this.equipmentBRs.push(this.editForm)
                :
                this.createEquipmentBRRequest(this.editForm)
          }

        } else {
          return false;
        }

      }


    },
    downloadReport(borrowing_id,extension){
      var url = config.baseURLApi + '/report/equipment_master_r_001?borrowing_id='+borrowing_id+'&extension='+extension
      window.open(url);
    },
    downloadReport2(extension){
      var url = config.baseURLApi + '/report/equipment_master_r_002?extension='+extension
      window.open(url);
    },
    downloadReport3(return_status,extension){
      var url = config.baseURLApi + '/report/equipment_master_r_003?return_status='+return_status+'&extension='+extension
      window.open(url);
    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },

    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },

    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await this.$refs.form.reset()
      this.resetValue()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },

    //Date Picker Format

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${(year) * 1 + 543}`
    },

    formatDateMonth(date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${(year) * 1 + 543}`
    },

    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    parseDateMonth(date) {
      if (!date) return null
      const [month, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}`
    },

    clearableDate(item) {
      if (item == 'start') {
        this.date3 = '';
      } else {
        this.date4 = '';
      }
      this.searchData();

    },

    checkStartEnd() {
      if (this.date3 != '' && this.date4 != '') {

        // แปลง string เป็น Date objects
        var startDateObject = new Date(this.date3);
        var endDateObject = new Date(this.date4);

        // เปรียบเทียบวันที่
        if (startDateObject > endDateObject) {

          this.showAlert("วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด", "warning")
          this.date3 = ''

        } else if (endDateObject < startDateObject) {
          this.showAlert("วันที่สิ้นสุด น้อยกว่า วันที่เริ่มต้น", "warning")
          this.date4 = ''

        }
      }
    },

    async checkStartEndNull() {
      if (this.date3 === '' || this.date4 === '') {

        this.showAlert("จำเป็นต้องระบุวันที่รับ-คืนวัสดุอุปกรณ์", "warning")

        return false; // Validation failed
      } else {

        if (this.equipment_br_items && this.equipment_br_items.length <= 0) {
          const isConfirmed = await this.showAlertDisableDate(); // Await the confirmation
          return isConfirmed; // Return the user's choice
        } else {
          return true;
        }

      }
    },

    async checkBorrowingStatus(status, type) {

      //เช็ค ถ้าไม่ใช่ admin

      if (type == 'edit') {
        if (!this.borrowing_status_text_color.find(item => item.status_code === status).edit && this.currentUser.role != 'admin') {
          this.$swal({
            title: "ขออภัย!",
            text: "สถานะเอกสารปัจจุปัน ไม่สามารถแก้ไขได้",
            icon: "warning",
            confirmButtonText: 'ตกลง',
          });
          return false;
        }
      } else {
        if (!this.borrowing_status_text_color.find(item => item.status_code === status).cancel && this.currentUser.role != 'admin') {
          this.$swal({
            title: "ขออภัย!",
            text: "สถานะเอกสารปัจจุปัน ไม่สามารถยกเลิกได้",
            icon: "warning",
            confirmButtonText: 'ตกลง',
          });
          return false;
        }
      }

      return true;

    },

    //for combobox select mouseover leave
    onItemSelected(selectedItemId) {


      // ตรวจสอบว่า selectedItemId ไม่ใช่ null หรือ undefined
      if (selectedItemId !== null && selectedItemId !== undefined) {
        // ค้นหารายการที่ตรงกับ selectedItemId
        const selectedItem = this.e_i_tem_combo.find(
            (item) => item.item_id === selectedItemId.item_id
        );

        // ถ้าพบรายการที่เลือก
        if (selectedItem) {
          this.editedEquipmentItem.item_id = selectedItem.item_id;
          this.editedEquipmentItem.item_h_image = this.baseURLStorage + selectedItem.item_h_image;
          //ดึงจำนวนที่พร้อมให้บริการ ส่งช่วงวันที่ไปด้วย
          this.editedEquipmentItem.item_quantity = 0;

          try {
            const formData = new FormData();
            formData.append('start_date', this.date3);
            formData.append('end_date', this.date4);
            formData.append('item_id', selectedItem.item_id);
            formData.append('borrowing_id', this.editForm.borrowing_id);

            axios.post(config.baseURLApi + '/get_item_quantity_max', formData, {
              headers: {},
            }).then(res => {

              this.editedEquipmentItem.item_quantity = res.data[0].available_quantity * 1

            });

          } catch (e) {
            this.showSnackbar(e);
          }


        } else {
          // alert("ไม่พบรายการที่เลือก");
          this.editedEquipmentItem.item_h_image = null;
        }
      } else {
        this.editedEquipmentItem.item_h_image = null;
      }
    },

    onMouseEnter(item) {

      this.editedEquipmentItem.item_h_image = this.baseURLStorage + item.item_h_image;
    },

    onMouseLeave() {

      if (this.editedEquipmentItem.item_id_full != null) {
        if (this.editedEquipmentItem.item_id_full.item_id !== null && this.editedEquipmentItem.item_id_full.item_id !== undefined) {

          const selectedItem2 = this.e_i_tem_combo.find(
              (item) => item.item_id === this.editedEquipmentItem.item_id_full.item_id
          );
          this.editedEquipmentItem.item_h_image = this.baseURLStorage + selectedItem2.item_h_image;
        } else {
          this.editedEquipmentItem.item_h_image = null;
        }
      } else {
        this.editedEquipmentItem.item_h_image = null;
      }


    },

    async addItemEquipment(item_id, add_type) {

      this.editedEquipmentItem.add_type = add_type;

      const isValid = await this.checkStartEndNull(); // Wait for the result of checkStartEndNull()
      if (isValid) {
        if (item_id != '') {

          // ตรวจสอบว่า item_id ของ editedEquipmentItem มีอยู่ใน equipment_br_items หรือไม่
          const isDuplicate = this.equipment_br_items.find(
              (item) => item.item_id === item_id
          );

          // ถ้ายังไม่มี ให้เพิ่มลงใน equipment_br_items
          if (!isDuplicate) {
            this.editedEquipmentItem.item_id_full = this.getItemDetailsById(item_id);
            //ดึงจำนวนที่พร้อมให้บริการ ส่งช่วงวันที่ไปด้วย
            this.editedEquipmentItem.item_quantity = 0;

            try {
              const formData = new FormData();
              formData.append('start_date', this.date3);
              formData.append('end_date', this.date4);
              formData.append('item_id', item_id);
              formData.append('borrowing_id', this.editForm.borrowing_id);

              axios.post(config.baseURLApi + '/get_item_quantity_max', formData, {
                headers: {},
              }).then(res => {

                this.editedEquipmentItem.item_quantity = res.data[0].available_quantity * 1

              });

            } catch (e) {
              this.showSnackbar(e);
            }

            this.editedEquipmentItem.item_id = this.editedEquipmentItem.item_id_full.item_id;
            this.editedEquipmentItem.item_h_image = this.baseURLStorage + this.editedEquipmentItem.item_id_full.item_h_image;

            console.log(this.editedEquipmentItem.item_id_full)

          } else {

            this.showAlert('ซ้ำ! รายการนี้ถูกเพิ่มในรายการแล้ว', "error")
            return false
          }

        } else {
          this.editedEquipmentItem.item_id_full = null;
          this.editedEquipmentItem.item_h_image = null;
        }

        this.defaultEquipmentItem = { //defaultItem
          item_id: item_id,
          item_quantity: 0, //set ค่าจำนวนที่พร้อมใช้ / Max
          borrowing_list_quantity: 0,
          remarks: '',
          add_type: add_type
        },
            this.dialog = true; // เปิด v-dialog
      }

      //console.log('item_id ที่ส่งมา ' + item_id)


    },

    editItemEquipment(item) {
      this.editedEquipmentIndex = this.equipment_br_items.indexOf(item)
      this.editedEquipmentItem = Object.assign({}, item)

      try {
        const formData = new FormData();
        formData.append('start_date', this.date3);
        formData.append('end_date', this.date4);
        formData.append('item_id', item.item_id);
        formData.append('borrowing_id', this.editForm.borrowing_id);

        axios.post(config.baseURLApi + '/get_item_quantity_max', formData, {
          headers: {},
        }).then(res => {

          this.editedEquipmentItem.item_quantity = res.data[0].available_quantity * 1

        });

      } catch (e) {
        this.showSnackbar(e);
      }

      this.dialog = true
    },

    editItemEquipmentStatus(item) {
      console.log(item)
      this.editedEquipmentIndex = this.equipment_br_items.indexOf(item)
      this.equipment_br_items[this.editedEquipmentIndex].return_status=2;

    },

  async  deleteItemEquipment(item) {
      this.editedEquipmentIndex = this.equipment_br_items.indexOf(item)
      this.editedEquipmentItem = Object.assign({}, item)
      //this.dialogDelete = true
      const isConfirmed = await this.showAlertDeleteItem();
     // console.log(isConfirmed);
      if(isConfirmed){
        this.equipment_br_items.splice(this.editedEquipmentIndex, 1)

      }
      this.$nextTick(() => {
        this.editedEquipmentItem = Object.assign({}, this.defaultEquipmentItem)
        this.editedEquipmentIndex = -1
      })
    },

 /*   deleteItemEquipmentConfirm() {
      this.equipment_br_items.splice(this.editedEquipmentIndex, 1)
      this.closeEquipmentDelete()
    },*/

    closeEquipment() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedEquipmentItem = Object.assign({}, this.defaultEquipmentItem)
        this.editedEquipmentIndex = -1
      })
    },

    /*closeEquipmentDelete() {
      //this.dialogDelete = false
      this.$nextTick(() => {
        this.editedEquipmentItem = Object.assign({}, this.defaultEquipmentItem)
        this.editedEquipmentIndex = -1
      })
    },*/

    saveEquipment() {


      if (this.editedEquipmentIndex > -1) {
        if (this.editedEquipmentItem.item_quantity < this.editedEquipmentItem.borrowing_list_quantity) {
          this.showAlert('จำนวนที่ต้องการยืมต้องไม่เกินจำนวนที่พร้อม', "error")
          return false
        } else {
          Object.assign(this.equipment_br_items[this.editedEquipmentIndex], this.editedEquipmentItem)
        }

      } else {

        // ตรวจสอบว่า item_id ของ editedEquipmentItem มีอยู่ใน equipment_br_items หรือไม่
        const isDuplicate = this.equipment_br_items.find(
            (item) => item.item_id === this.editedEquipmentItem.item_id
        );

        // ถ้ายังไม่มี ให้เพิ่มลงใน equipment_br_items
        if (!isDuplicate) {
          if (this.editedEquipmentItem.item_quantity < this.editedEquipmentItem.borrowing_list_quantity) {
            this.showAlert('จำนวนที่ต้องการยืมต้องไม่เกินจำนวนที่พร้อม', "error")
            return false
          } else {
            this.equipment_br_items.push(this.editedEquipmentItem);
          }

        } else {
          this.showAlert('ซ้ำ! รายการนี้ถูกเพิ่มในรายการแล้ว', "error")
          return false
        }

      }
      this.closeEquipment()
    },


    showRemark(borrowing_id) {
      this.remark_items = [];
      try {
        const formData = new FormData();

        formData.append('borrowing_id', borrowing_id);

        axios.post(config.baseURLApi + '/get_e_borrowing_log', formData, {
          headers: {},
        }).then(res => {

          this.remark_items = res.data
          this.dialogRemark = true

        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },

    // ฟังก์ชันสำหรับดึงข้อมูล
    getItemDetailsById(itemId) {
      // ใช้ find() เพื่อค้นหา item_id ที่ตรงกัน
      const itemDetails = this.e_i_tem_combo.find(item => item.item_id === itemId);
      return itemDetails || null;
    },

    searchData() {
      this.checkStartEnd();
      this.search_data.start_date = this.date3;
      this.search_data.end_date = this.date4;
      this.getEquipmentBRsRequest(this.search_data);
    },

    getStatusData(status) {
      return this.borrowing_status_text_color.find((item) => item.status_code === status) || null;
    },

    getReturnStatusData(status) {
      return this.return_status_text_color.find((item) => item.status_code === status) || null;
    },

    checkType(user_name) {

      //เช็ครูปแบบ user name ว่าเป็น นิสิต/บุคลากร
      if (typeof user_name === "string" && !isNaN(user_name)) {
        return true;
        // console.log("user_name เป็นตัวเลข (ในรูปแบบข้อความ)");
      } else if (typeof user_name === "string") {
        return false;
        //console.log("user_name เป็นข้อความ");
      } else if (typeof user_name === "number") {
        return true;
        // console.log("user_name เป็นตัวเลข");//
      } else {
        return false;
        //console.log("user_name เป็นชนิดอื่น");
      }
    },

    async beforeMount() {

    },

  }
  ,
}
</script>

<style src="../EquipmentBR/EquipmentBR.scss" lang="scss"/>
<style scoped>
.custom-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* สร้าง 3 คอลัมน์ */
  gap: 8px; /* เพิ่มช่องว่างระหว่างไอเทม */
}
</style>